import { Grid, Typography } from '@mui/material'

import { Author } from '@ecm/data/Author'
import AuthorPhoto from '@ecm/ui/component/blog/AuthorPhoto'
import Anchor from '@ecm/ui/element/Anchor'
import Color from '@ecm/ui/element/Color'

type BylineProps = {
  author: Author
  publishedDate: string
}

const Byline = ({ author, publishedDate }: BylineProps) => (
  <Grid container alignItems="center" width="100%" flexWrap="nowrap">
    {author.photoUrl && <AuthorPhoto src={author.photoUrl} alt={author.fullname} />}
    <Anchor href={`/blog/author/${author.id}`}>
      <Typography
        variant="overline"
        sx={{
          '&:hover': { color: Color.saint.normal },
          color: Color.slate.lighter,
          fontSize: '11px',
          mr: '0.5em',
        }}
      >
        {author.fullname}
      </Typography>
    </Anchor>
    <Typography
      variant="overline"
      color={Color.slate.lighter}
      fontSize="11px"
      sx={{
        '&:before': {
          color: Color.slate.lighter,
          content: '"•"',
          fontWeight: 700,
          marginRight: '.5em',
        },
      }}
    >
      {publishedDate}
    </Typography>
  </Grid>
)

export default Byline
